import React from "react";
import FormGroup from "@mui/material/FormGroup";
import RadioGroup from "@mui/material/RadioGroup";
import Box from "@mui/material/Box";
import CCheckButton from "./CCheckButton";

const CCheckGroup = ({
  cId,
  cData,
  cIsSingle,
  cLabelEmpty,
  cOnChange,
  cIsSmall,
  dcat,
}) => {
  const onChange = (key, isChecked) => {
    if (cOnChange !== undefined) {
      cOnChange(key, isChecked);
    }
  };

  if (!cData || !cData.data || cData.data.size === 0) {
    return null;
  }

  const { data, filters, checks } = cData;

  // Get all entries that should be displayed
  const entries = [...data.entries()].filter(([key]) => filters.has(key));

  // Generate check button components for all entries
  const checkButtons = entries.map(([key, item]) => (
    <CCheckButton
      cId={cId}
      key={key}
      cLabel={item === null ? cLabelEmpty : item}
      cChecked={checks.has(key)}
      cIsSingle={cIsSingle}
      cHandleCheck={() => onChange(key, true)}
      cHandleUnCheck={() => onChange(key, false)}
      cIsSmall={cIsSmall}
      dcat={dcat}
    />
  ));

  // Style for the container
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    height: "13.5em",
    ...(dcat
      ? {
          padding: "0 1em",
          gap: "0",
        }
      : {
          padding: "1em",
        }),
    willChange: "transform",
    WebkitOverflowScrolling: "touch",
  };

  // Render appropriate group component
  const Content = cIsSingle ? (
    <RadioGroup value={cIsSingle ? [...checks][0] : undefined}>
      {checkButtons}
    </RadioGroup>
  ) : (
    <FormGroup>{checkButtons}</FormGroup>
  );

  // Return the appropriate container
  return dcat ? (
    <Box sx={containerStyle}>{Content}</Box>
  ) : cIsSingle ? (
    <RadioGroup sx={containerStyle}>{checkButtons}</RadioGroup>
  ) : (
    <FormGroup sx={containerStyle}>{checkButtons}</FormGroup>
  );
};

export default CCheckGroup;
